export default __webpack_public_path__ + "23a2a11e67dcc1b0f652998f04a2856b.png";